import isString from "lodash/isString";
import isEmpty from "lodash/isEmpty";
import type { GTM } from "../GTMInterfaces";
import { getServicesCashbackPartnerCollection } from "./servicesWithCashbackFromPartners";

export function hasCashbackFromPartner(service: GTM.ServiceExtended): boolean {
  const productsWithCashbackFromPartner = getServicesCashbackPartnerCollection();
  if (isEmpty(service?.unique_identifier)) {
    return false;
  }

  if (!isString(service?.unique_identifier)) {
    return false;
  }

  const identifiers = Array.from(productsWithCashbackFromPartner.keys());
  return identifiers.includes(service.unique_identifier);
}
